import { GET_AVAILABLE_EMPLOYEES_DELEGATION } from "../../../../enums/MyDivision/Delegation/AuthorityDelegation.types";

export const getAvailableEmployeesDelegationAction = (employees) => {
    return {
        type: GET_AVAILABLE_EMPLOYEES_DELEGATION,
        payload: employees,
    };
};